import { memo, VFC } from 'react';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import jaLocale from 'date-fns/locale/ja';
import format from 'date-fns/format';

type Props = {
  date: Date | null;
  onChange: (date: Date | null, value?: string | null | undefined) => void;
  id: string;
  emptyLabel?: string | null;
  minDate?: Date | null;
  maxDate?: Date | null;
  disabled?: boolean;
};

class ExtendedUtils extends DateFnsUtils {
  getCalendarHeaderText(date: Date) {
    return format(date, 'yyyy年 MMM', { locale: this.locale });
  }
  getDatePickerHeaderText(date: Date) {
    return format(date, 'MMMd日', { locale: this.locale });
  }
  getYearText = (date: Date): string => {
    return `${date.getFullYear()}年`;
  };
}

const DatePickerInput: VFC<Props> = props => {
  const { date, onChange, id, emptyLabel, minDate, maxDate, disabled } = props;

  return (
    <MuiPickersUtilsProvider utils={ExtendedUtils} locale={jaLocale}>
      <KeyboardDatePicker
        variant='dialog'
        clearable
        okLabel={false}
        minDate={minDate}
        maxDate={maxDate}
        clearLabel='クリア'
        cancelLabel='キャンセル'
        style={{ width: '100%' }}
        format='yyyy年MM月dd日'
        margin='normal'
        id={id}
        value={date}
        emptyLabel={emptyLabel || '選択してください。'}
        InputProps={{
          disableUnderline: true,
          readOnly: true
        }}
        autoOk={true}
        onChange={onChange}
        KeyboardButtonProps={{
          'aria-label': 'change date'
        }}
        disabled={disabled}
      />
    </MuiPickersUtilsProvider>
  );
};

export default memo(DatePickerInput);
